import { Metamodel } from 'app/model/base/model';
import { AzureBlobStorageLinkedService } from 'app/model/linkedservice/azure-blob-storage.linkedservice';
import { AdvancedStoreWriteSettings } from './advanced-store-write-settings';

@Metamodel.model({
    name: 'AzureBlobStorageWriteSettings',
    tags: {
        linkedServiceModel: [Metamodel.modelFor(AzureBlobStorageLinkedService)]
    }
})

export class AzureBlobStoreWriteSettings extends AdvancedStoreWriteSettings {

}
